import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useEffect, useState } from "react";
import Loader from "./Loader";

function PrivateRoute({ children, allowedRoles }) {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAuthorized(false);
        setLoading(false);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (!snap.exists()) {
          setAuthorized(false);
        } else {
          const { role } = snap.data();

          // ✅ SAFE CHECK (fixes includes error)
          if (!allowedRoles || allowedRoles.includes(role)) {
            setAuthorized(true);
          } else {
            setAuthorized(false);
          }
        }
      } catch (err) {
        console.error(err);
        setAuthorized(false);
      }

      setLoading(false);
    });

    return () => unsub();
  }, [allowedRoles]);

  if (loading) return <Loader />;

  if (!authorized) return <Navigate to="/EmpLogin" replace />;

  return children;
}

export default PrivateRoute;
